/*
 * NextGenn engine · things arrive.
 *
 * ONE reveal for the whole shop, not twenty. A heading, a paragraph, a card or
 * a photograph lifts a centimetre and fades in as it comes up the screen, once,
 * and then it is furniture like everything else. Cards in a row go one after
 * another, a tenth of a second apart, because a row that arrives all at once
 * reads as a page that was slow rather than a page that is alive.
 *
 * THE HIDDEN STATE IS ADDED BY THIS FILE, NEVER BY THE STYLESHEET. If it were
 * in the CSS, a visitor whose script never arrives would get a shop of empty
 * cream: everything would be waiting to be revealed by a file that is not
 * there. Written this way the worst case is a page with no animation at all.
 *
 * It does nothing at all when the visitor has asked for less motion, when the
 * browser is old enough to lack IntersectionObserver, or above the fold, where
 * a fade-in is just a slower page.
 */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* What is worth revealing: the things a reader's eye lands on. Deliberately
     not "every element" — a shop where the small print fades in is a shop that
     feels slow. */
  var WORTH = [
    '.ngs-section h2',
    '.ngs-section h3',
    '.ngs-places__lede, .ngs-story__lines, .ngs-story__quote, .ngs-assure__tile',
    '.ngs-places__card, .ngs-shelf__card, .ngs-faces__card, .ngs-box__card',
    '.ngs-concerns__card, .ngs-offer, .ngs-order__step, .ngs-routine__step',
    '.ngs-reviews__summary, .ngs-reviews__item, .ngs-voices__card',
    '.ngs-story__frame, .ngs-use__figure, .ngs-compare__stage',
    '.ngs-shade__ask, .ngs-quiz__plate',
    /* Dawn's own collection grid, which is the second most looked-at page in
       the shop and was the one page with nothing arriving on it. Scoped to the
       grid itself, never to `.grid__item` at large: the same class carries the
       quick-add panel and the search results. */
    '#product-grid > .grid__item',
    '.collection .card-wrapper',
  ].join(',');

  var FOLD = window.innerHeight * 1.05;
  var seen = new WeakSet();
  var pending = [];

  function show(node) {
    node.classList.add('is-in');
    watcher.unobserve(node);
    var at = pending.indexOf(node);
    if (at > -1) pending.splice(at, 1);
  }

  var watcher = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        show(entry.target);
      });
    },
    /* A little before the edge, so a card is already settled by the time it is
       properly readable rather than moving under the eye. */
    { rootMargin: '0px 0px -8% 0px', threshold: 0.01 }
  );

  /* AN OBSERVER ONLY REPORTS A CROSSING, and a page can be moved without
     crossing anything: an anchor, the back button restoring a position, a hard
     flick on a phone. Everything the jump passed over stays hidden, and it is
     hidden for good, because it will never enter the viewport again from below
     — the visitor finds it by scrolling back UP into a screen of blank cream.
     So the crossings are the cheap path and this is the honest one: after any
     scroll, whatever is now at or above the fold is simply shown. */
  var sweeping = false;
  function sweep() {
    sweeping = false;
    var edge = window.innerHeight;
    pending.slice().forEach(function (node) {
      if (node.getBoundingClientRect().top < edge) show(node);
    });
    if (!pending.length) window.removeEventListener('scroll', onScroll);
  }
  function onScroll() {
    if (sweeping) return;
    sweeping = true;
    window.requestAnimationFrame(sweep);
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  function dress(root) {
    var found = (root || document).querySelectorAll(WORTH);
    Array.prototype.forEach.call(found, function (node, order) {
      if (seen.has(node)) return;
      seen.add(node);
      /* Already on screen when the page loaded: it is not arriving, it is here. */
      if (node.getBoundingClientRect().top < FOLD) return;
      node.classList.add('ngs-r');
      /* Siblings go one after another; the count restarts inside each parent,
         so a row of four staggers and the next row does not start at four. */
      var kin = node.parentElement ? node.parentElement.children : [];
      var place = Array.prototype.indexOf.call(kin, node);
      node.style.setProperty('--ngs-r-step', String(Math.min(place, 6)));
      pending.push(node);
      watcher.observe(node);
    });
  }

  dress(document);

  /* Sections the theme editor redraws, and anything a section adds later. */
  document.addEventListener('shopify:section:load', function (event) {
    dress(event.target);
    if (pending.length) window.addEventListener('scroll', onScroll, { passive: true });
  });
})();
